import React from "react";

import { ProductOutlined } from '@ant-design/icons';

import cattleRoutes from "./cattles/routes";
import carabaoRoutes from "./carabaos/routes";
import goatRoutes from "./goats/routes";
import sheepRoutes from "./sheeps/routes";
import swineRoutes from "./swines/routes";
import { MODULE_DA_ANIMAL_INV } from "variables/constants";

const animalInventoryRoutes = [	
	{
		name: "DA Animal Inventory",
		layout: "/console",
		path: "#",    
		component: null,
		isMainMenu:true,
		icon: <ProductOutlined className="h-6 w-6"/>,
		level: 4,
		moduleId: MODULE_DA_ANIMAL_INV,
		children: [
		  ...cattleRoutes,  
		  ...goatRoutes,
		  ...sheepRoutes,
		]
	},
]

export default animalInventoryRoutes;